/**
 * Utility for hashing puzzle solutions using SHA-256
 * Used to store solution verification without exposing plaintext
 */

export async function hashSolution(solution: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(solution.toUpperCase());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Verify a solution against a stored hash
 */
export async function verifySolutionHash(solution: string, hash: string): Promise<boolean> {
  const computedHash = await hashSolution(solution);
  return computedHash === hash;
}
